import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { Layout } from 'react-admin';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { SocketProvider } from '../contexts/SocketProvider';
import EventBannerProvider from '../contexts/EventBannerProvider';
import { TerminalsProvider } from '../contexts/TerminalsProvider';
import { OwnerCompanyDataProvider } from '../contexts/OwnerCompanyDataProvider';
import { UserSettingsProvider, useUserSettingsContext } from '../contexts/UserSettingsProvider';

import { MyAppBar } from './AppBar';
import { GridUserDataGlobalFiltersProvider } from 'contexts/GridUserDataGlobalFiltersProvider';
import { SPPScannerProvider } from 'components/Scanner/GlobalSPPScanner';


export const MyLayout = props => {    
    const { data: userSettings } = useUserSettingsContext();
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (userSettings) {
            dispatch({ type: 'SET_SIDEBAR_OPEN', payload: !userSettings.is_menu_collapse });
        }
    }, [userSettings]);

    return (<Layout {...props} appBar={MyAppBar} />)
};


export default (props) => (
    <SocketProvider>
        <EventBannerProvider>
            <TerminalsProvider>
                <OwnerCompanyDataProvider>
                    <UserSettingsProvider>
                        <GridUserDataGlobalFiltersProvider>
                            <SPPScannerProvider>
                                <MyLayout {...props} />
                                <ToastContainer autoClose={false} position="bottom-right" />
                            </SPPScannerProvider>
                        </GridUserDataGlobalFiltersProvider>
                    </UserSettingsProvider>
                </OwnerCompanyDataProvider>
            </TerminalsProvider>
        </EventBannerProvider>
    </SocketProvider>
);